// extracted by mini-css-extract-plugin
module.exports = {"loading-view":"LoadingView_loading-view__1s-Wh"};